module.exports = __webpack_public_path__ + "img/bell_3.bc2c3381.jpg";